import { map, catchError } from 'rxjs/operators';
// Rxjs import
import { of } from 'rxjs';
// Service imports
import { ServerErrorService } from '../_services/shared-services/server-error.service';
import { ContextManagerService } from '../_services/data-services/context-manager.service';
// Model imports
import { PropertyCommunityInfoParameterDto } from '../_models/property-community-info-parameter-dto';
import * as i0 from "@angular/core";
import * as i1 from "../_services/shared-services/server-error.service";
import * as i2 from "../_services/data-services/context-manager.service";
export class ContextGuard {
    constructor(errorService, contextManagerService) {
        this.errorService = errorService;
        this.contextManagerService = contextManagerService;
    }
    canActivate(route, state) {
        const communityId = route.params.communityId;
        const customerId = route.params.customerId;
        const stateURL = state.url;
        const url = this.getConfiguredUrl(route);
        this.contextManagerService.setSelectedContextRouteItem(url);
        if (communityId || customerId) {
            return this.setApplicationContext(communityId, customerId);
        }
        else {
            return this.getContextFromStateURL(stateURL);
        }
    }
    setApplicationContext(communityId, customerId) {
        const baseParams = new PropertyCommunityInfoParameterDto();
        baseParams.communityId = parseInt(communityId);
        baseParams.customerId = customerId || null;
        baseParams.clearCache = true;
        return this.contextManagerService.getContextInfo(baseParams).pipe(map((data) => {
            this.contextManagerService.updateContext(data);
            return true;
        }), catchError((error) => {
            this.errorService.displayError(error);
            return of(false);
        }));
    }
    getConfiguredUrl(route) {
        const tabName = route.params.tabName;
        let configURL = '/' +
            route.pathFromRoot
                .filter((v) => v.routeConfig && !!v.routeConfig.path)
                .map((v) => v.routeConfig.path)
                .join('/');
        if (!!tabName && configURL.endsWith('tabName')) {
            configURL = configURL.replace(':tabName', tabName);
        }
        return configURL;
    }
    getContextFromStateURL(stateURL) {
        let communityId;
        let customerId;
        const tokens = stateURL.split('/');
        for (const token of tokens) {
            if (token.length) {
                if (parseInt(token)) {
                    communityId = token;
                }
                else if (token.startsWith('R')) {
                    customerId = token;
                }
            }
            if (customerId && communityId) {
                break;
            }
        }
        return this.setApplicationContext(communityId, customerId);
    }
}
ContextGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ContextGuard_Factory() { return new ContextGuard(i0.ɵɵinject(i1.ServerErrorService), i0.ɵɵinject(i2.ContextManagerService)); }, token: ContextGuard, providedIn: "root" });
